module.exports = global["jQuery"] = require("-!E:\\Git\\vportal2public\\gnmobis\\skin-2021\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");